<template>
  <div class="tw:flex tw:w-full tw:items-center tw:gap-3">
    <Checkbox
      class="tw:m-0! tw:h-auto!"
      data-testid="checkbox-select-all"
      :disabled="disabled"
      :indeterminate="indeterminate"
      :model-value="modelValue"
      new-design
      @update:model-value="emits('update:modelValue', $event)"
    />
    <BaseButton
      bordered
      class="tw:p-1 tw:capitalize"
      color="white"
      data-testid="button-select-all"
      :disabled="disabled"
      :label="label"
      name="select_all"
      new-design
      @click="emits('update:modelValue', !modelValue)"
    />
    <div
      v-if="displayTotal"
      class="tw:ml-auto"
    >
      <BaseButton
        class="tw:text-blue-900"
        data-testid="delete-all"
        :disabled="disabled"
        flat
        icon="delete_outline"
        icon-right
        icon-size="26px"
        :label="getLocaleText('global.total_selected', { total: selected })"
        new-design
        @click="emits('delete-all')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { getLocaleText } from "shared/boot/i18n";
import { BaseButton } from "shared/components/base";
import Checkbox from "shared/components/core/forms/Checkbox.vue";

interface SelectAllCheckboxButtonProps {
  disabled?: boolean;
  indeterminate?: boolean;
  modelValue: boolean;
  pageSize?: number;
  renderDeleteButton?: boolean;
  selected?: number;
}

const props = withDefaults(defineProps<SelectAllCheckboxButtonProps>(), {
  pageSize: 20,
  selected: 0,
});

const label = computed(() =>
  getLocaleText("global.select_all_total", { total: props.pageSize })
);

const displayTotal = computed(() => props.renderDeleteButton && props.selected);

const emits = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "delete-all"): void;
}>();
</script>
